import React from 'react';
import './PreCutFilmsPage.css';

const PreCutFilmsPage = () => {
  return (
    <div className="pre-cut-films-main">
      <section className="pre-cut-films-hero">
        <div className="pre-cut-films-hero-content">
          <h1>Pre-Cut Films</h1>
          <p>Precision-cut window films for perfect fit and professional installation</p>
        </div>
      </section>

      <section className="pre-cut-films-main-content">
        <h2>Pre- Cut Films</h2>
        <p><strong>Exclusively for Skin and Eye Care Series only.</strong></p>
        <h3>Precision-Cut Tint Kits for a Perfect DIY Fit</h3>
        <p>Looking for a hassle-free, professional-grade tinting solution you can install yourself? Our Pre-Cut Car Window Tinting Kits are custom-designed to match the exact specifications of your vehicle's windows—cut with precision using advanced computer-controlled plotters.<br/>No trimming. No guesswork. Just peel, apply, and enjoy.</p>
        <div className="pre-cut-main-image-container">
            <img 
            src="https://i.postimg.cc/j5k0SHz8/pre-cut-derma-film-2-1.png" 
            alt="Pre-Cut Derma Film Example" 
            className="pre-cut-main-image"
            />
        </div>
        <hr />
        <h3>🔧 Precision Fit for Every Vehicle</h3>
        <p>Our vast vehicle database ensures that every pre-cut film is tailored to your make and model—down to the exact millimeter. Whether you're tinting just the front door windows or going for full coverage including rear windows and windshields, our kits are engineered to fit flawlessly.</p>
        <hr />
        <h3>⚙️ Why Choose Pre-Cut Tints?</h3>
        <ul>
          <li>✅ <strong>Perfect Fit, Every Time</strong><br/>Each tint film is laser-cut to fit the shape and curve of your specific vehicle windows—ensuring a factory-style finish without manual trimming.</li>
          <li>✅ <strong>DIY-Friendly Installation</strong><br/>Pre-cut kits are ideal for enthusiasts or first-timers. No large, unmanageable rolls—just vehicle-specific pieces that are easy to handle and apply.</li>
          <li>✅ <strong>Time-Saving Convenience</strong><br/>With no measuring or cutting required, you can complete your tinting job in a fraction of the time it would normally take.</li>
          <li>✅ <strong>Reduced Risk of Mistakes</strong><br/>Since every piece is already precision cut, the risk of bubbles, overlapping edges, or incorrect sizing is minimized—so you can install with confidence.</li>
          <li>✅ <strong>Professional-Grade Quality</strong><br/>We only use premium-grade, automotive window films in our kits—durable, fade-resistant, and built to last. Expect top-tier UV rejection, heat control, and optical clarity.</li>
        </ul>
        <hr />
        <h3>🛠️ What's Included in the Kit?</h3>
        <ul>
          <li>Pre-cut film for all selected windows (front, rear, quarter glass, etc.)</li>
          <li>Optional visor strip for windshields (available on request)</li>
          <li>Step-by-step installation guide</li>
          <li>Optional application tool kit (available for add-on)</li>
        </ul>
        <hr />
        <h3>💡 Popular Among:</h3>
        <ul>
          <li>✔️ DIY car enthusiasts</li>
          <li>✔️ Auto detailers and tint installers</li>
          <li>✔️ Car dealerships and fleets</li>
          <li>✔️ Customers seeking budget-friendly professional results</li>
        </ul>
        <hr />
        <h3>📦 We Offer Kits For:</h3>
        <ul>
          <li>Sedans</li>
          <li>SUVs</li>
          <li>Coupes</li>
          <li>Vans</li>
          <li>Hatchbacks</li>
            </ul>
        <hr />
        <h3>🛡️ Backed by Warranty</h3>
        <p>Our pre-cut film kits are backed by a 5 year- warranty protecting you against peeling, bubbling, cracking, or fading.</p>
        <hr />
        <p>Upgrade your car's look and comfort in one go—without breaking the bank or stepping into a shop. Our pre-cut kits bring professional results straight to your garage.</p>
      </section>

        <div className="cta-section">
          <h2>Ready for Perfect Fit?</h2>
          <p>
            Experience the convenience and precision of our pre-cut window films. 
            Contact us today to find the perfect fit for your vehicle or learn more 
            about our pre-cut solutions.
          </p>
          <div className="cta-buttons">
            <button className="cta-button secondary">Coming Soon</button>
        </div>
      </div>
    </div>
  );
};

export default PreCutFilmsPage; 